import { Box, capitalize, Typography } from "@mui/material"
import { EuropcarPieChart, EuropcarTable } from "Pages/BusinessLogistics/Analytics/Page/@components/index"
import { REQUEST_TYPE } from "Pages/BusinessLogistics/Analytics/Page/@constants"
import React from "react"

export default function EuropcarInfoBlock({ label }) {
	
	return <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
		<Typography variant="h4">
			{`Searches by ${capitalize(label)}`}
		</Typography>
		<Box sx={{ width: '100%' }}>
			<EuropcarPieChart requestType={`${label}-${REQUEST_TYPE.CHART}`}/>
		</Box>
		<Box sx={{ width: '100%' }}>
			<EuropcarTable requestType={`${label}-${REQUEST_TYPE.TABLE}`} label={capitalize(label)}/>
		</Box>
	</Box>
}